import { Journey } from '@audibene/ta.utils-opportunity'
import { useQuery } from 'react-query'
import { AppointmentType } from '../../constants'
import { QueryOptions } from '../../types'
import { logFactory } from '../../util'
import { useAppointmentsService } from '../services'
import type { GetUnavailabilitiesRequest } from '../services/appointments/unavailabilities'

interface Props {
  appointmentType: AppointmentType
  dateEnd: Date
  dateStart: Date
  durationInMinutes: number
  journey: Journey
  resourceId: string
  resourceTimeZone: string
}

const hookName = 'useAvailabilitiesView'
const log = logFactory(hookName)

const useAvailabilitiesView = (props: Props, { enabled = true }: QueryOptions = {}) => {
  const { resourceId, journey } = props
  const { getUnavailabilities, isReady } = useAppointmentsService()
  const isEnabled = Boolean(resourceId)

  const unavailabilitiesRequest: GetUnavailabilitiesRequest = {
    appointment_type: props.appointmentType,
    date_end: props.dateEnd,
    date_start: props.dateStart,
    duration_in_minutes: props.durationInMinutes,
    journey,
    resource_ids: [resourceId],
  }

  const fetchUnavailabilities = async () => {
    log(`📆 Fetching unavailabilities...`, unavailabilitiesRequest)

    const found = await getUnavailabilities(unavailabilitiesRequest)

    log(`📆 Found unavailabilities`, found)

    return found
  }

  const isUnavailabilitiesQueryEnabled = Boolean(enabled && isReady && isEnabled)

  return useQuery([hookName, unavailabilitiesRequest], fetchUnavailabilities, {
    enabled: isUnavailabilitiesQueryEnabled,
  })
}

export { useAvailabilitiesView }
